import Grid from '@material-ui/core/Grid'; import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';

import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';
import { getLeadersList, setLeaderSearchTerm, setLeadersList, setFollowFilter } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
      minWidth: '300px',
    },
  }),
);

export default function LeaderSearch(props: any) {
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const listConfig = useSelector((state: any) => state.leaders.listConfig);
  const currUser = useSelector((state: any) => state.auth.currUser);

  const handleFormChange = (event: any) => {
    dispatch(setLeaderSearchTerm(event.target.value));
  };

  const handleLeaderSearch = (event: any) => {
    if (listConfig.search.length > 0) {
      getLeadersList(
        currUser,
        {
          ...listConfig,
          search: listConfig.search.toLowerCase(),
        },
        dispatch,
      );
    } else {
      dispatch(setLeadersList([]));
    }

    dispatch(setFollowFilter(null));
  };

  return (
    <Grid item container className={classes.root}>
      <FormControl fullWidth>
        <TextField
          size="small"
          label="Search for leader, church or ministry"
          value={listConfig.search}
          variant="outlined"
          onChange={handleFormChange}
          InputProps={{
            endAdornment:
              (<InputAdornment position="end">
                <IconButton
                  aria-label="search leaders"
                  edge="end"
                  onClick={handleLeaderSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>),
          }} />
      </FormControl>
    </Grid>
  );
}
